import React, {FC} from 'react'
import {Route} from 'react-router-dom'
import {shallowEqual, useSelector} from 'react-redux'
import { Routes as RouterRoutes } from 'react-router-dom'
import { Navigate } from 'react-router-dom'
import { ErrorsPage } from '@/modules/errors/ErrorsPage'
import { PublicRoutes } from './PublicRoutes'
import { PrivateRoutes } from './PrivateRoute'
import { Logout } from '@/modules/auth/components/Logout'
import { RootState } from '@/setup'
import MainLayout from '@/__core/layout/MainLayout'
import Apps from '@/app/apps/Apps'
import { getSelectedCompany } from '@/modules/auth/helpers/CompanyStorage'
import { getStoredAccessToken } from '@/modules/auth/helpers/TokenStorage'

const Routes: FC = () => {
  const accessToken = useSelector<RootState>(({auth}) => auth.accessToken, shallowEqual)
  const selectedCompany = useSelector<RootState>(({auth}) => auth.selectedCompany, shallowEqual)
  const storedAccessToken = getStoredAccessToken()
  const effectiveAccessToken = accessToken || storedAccessToken || undefined
  const effectiveSelectedCompany = selectedCompany || getSelectedCompany()
  const authEntryElement = effectiveAccessToken && effectiveSelectedCompany ? <Navigate to='/main' replace /> : <PublicRoutes />

  return (
    <RouterRoutes>
      <Route path='/error/*' element={<ErrorsPage />} />
      <Route path='/logout' element={<Logout />} />
      
      {/* /login route */}
      <Route path='/login' element={authEntryElement} />
      
      {/* Auth routes */}
      <Route path='/auth/*' element={authEntryElement} />
      
      {/* Private routes - require auth token + selected company context. */}
      {effectiveAccessToken && effectiveSelectedCompany ? (
        <>
          {/* Apps route without MainLayout */}
          <Route path='/apps' element={<Apps />} />
          {/* Default redirect to main */}
          <Route path='/' element={<Navigate to='/main' replace />} />
          {/* Other routes with MainLayout */}
          <Route path='/*' element={
            <MainLayout>
              <PrivateRoutes />
            </MainLayout>
          } />
        </>
      ) : (
        /* Redirect to auth if not fully authorized, but exclude /auth/* routes */
        <Route path='*' element={<Navigate to='/auth/login' replace />} />
      )}
    </RouterRoutes>
  )
}

export {Routes}
